export default {
  "content": "<g fill-rule=\"evenodd\" clip-path=\"url(#icon_resize_reduce_outlined_svg__a)\" clip-rule=\"evenodd\"><path d=\"M2.157 9.36c0-.28.22-.5.5-.5h3.955c.14-.01.28.04.39.15.09.09.15.22.15.35v4c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-2.79L.86 15.85c-.2.2-.51.2-.71 0a.497.497 0 010-.71l5.284-5.29H2.647c-.28 0-.5-.22-.5-.5l.01.01zm11.686-2.72c0 .28-.22.5-.5.5H9.388a.496.496 0 01-.39-.15.51.51 0 01-.15-.35v-4c0-.28.22-.5.5-.5s.5.22.5.5v2.79L15.14.15c.2-.2.51-.2.71 0 .199.2.199.51 0 .71l-5.284 5.29h2.786c.28 0 .5.22.5.5l-.01-.01z\"/></g><defs><clipPath id=\"icon_resize_reduce_outlined_svg__a\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};